import {connect} from 'react-redux';

import {buildContactsManagerCardGroupContactsUrl} from '../../../../../../../src/helpers/contactsManagerHelpers';
import {batch} from '../../../../../../../src/helpers/reduxHelpers';
import {CardGroupModel} from '../../../../../../../src/models/api/cardGroupModel';
import {CollapsedItemKeyPrefixesEnum} from '../../../../../../../src/models/api/localPreferencesModel';
import {ThunkAction} from '../../../../../../../src/store/appThunk';
import {toggleExpandItemAction} from '../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getFindIsExpanded} from '../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {contactsManagerTableForceRefreshAction} from '../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {navigateToLinkAction} from '../../../../../../../src/store/stateless/navigationActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {CardGroupsPage} from './cardGroupsPage';

/*
 * Constants.
 */

const infoBoxExpandedKey = `${CollapsedItemKeyPrefixesEnum.LISTS}infoBox`;
const isInfoBoxExpandedDefault = true;

/*
 * Selectors.
 */

const getIsInfoBoxExpanded = createSelector([getFindIsExpanded], (findIsExpanded) =>
  findIsExpanded(infoBoxExpandedKey, isInfoBoxExpandedDefault),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isInfoBoxExpanded: getIsInfoBoxExpanded,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onCreateSuccess:
    (cardGroup?: CardGroupModel): ThunkAction =>
    (dispatch) =>
      batch(() => {
        dispatch(contactsManagerTableForceRefreshAction());
        if (cardGroup) {
          dispatch(navigateToLinkAction(buildContactsManagerCardGroupContactsUrl(cardGroup.id)));
        }
      }),
  onToggleInfoBox: () => toggleExpandItemAction(infoBoxExpandedKey, isInfoBoxExpandedDefault),
}));

export const CardGroupsPageContainer = connect(mapStateToProps, mapDispatchToProps)(CardGroupsPage);
